/**
 * BizFile preview credentials for a single deployment (app Biz File, NCR BizForm, or operator BizForm).
 */
export interface BizFileFileInfo {
    baseUrl?: string;
    token?: string;
}

/**
 * Builds a private preview URL when {@link BizFileFileInfo} has {@code baseUrl} and {@code token}.
 */
export function buildBizFilePreviewUrl(
    fileInfo: BizFileFileInfo | null | undefined,
    fileGuid?: string,
    fileExtension?: string,
): string | undefined {
    if (!fileGuid?.trim()) {
        return undefined;
    }
    const baseUrl = fileInfo?.baseUrl?.trim();
    const token = fileInfo?.token;
    if (!baseUrl || !token) {
        return undefined;
    }
    const ext = fileExtension ? `.${fileExtension}` : "";
    return `${baseUrl}${fileGuid}${ext}${token}`;
}

/**
 * Builds a public preview URL (no auth token suffix).
 */
export function buildBizFilePublicPreviewUrl(
    fileInfo: BizFileFileInfo | null | undefined,
    fileGuid?: string,
    fileExtension?: string,
): string | undefined {
    if (!fileGuid?.trim()) {
        return undefined;
    }
    const baseUrl = fileInfo?.baseUrl?.trim();
    if (!baseUrl) {
        return undefined;
    }
    const ext = fileExtension ? `.${fileExtension}` : "";
    return `${baseUrl}${fileGuid}${ext}`;
}
